import { makeGraphQLQuery } from '../request.gql';

/**
 * LEAVE BARTER
 */
export const updateLeaveBarterSelectedOption = async ({
    leaveBarterId,
    type,
    numberOfDays,
    token,
}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `mutation (
                $id: ID!, 
                $type: String!,
                $numberOfDays: Int!,
            ) {
            leave_barter_option_change(
                id: $id,
                type: $type,
                numberOfDays: $numberOfDays,
            ) 
        }`,
        variables: {
            id: leaveBarterId,
            type,
            numberOfDays,
        },
        token,
    });
    if (e) return e;
    return r.leave_barter_option_change;
};
export const queryLeaveBarterConfig = async ({
    token,
}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `query {
            leave_barter_config {
                id
                pricePerDay
                type
                daysAllowed
                enableDeduction
                isManagerApprovalRequired
                customWarningMessage
                status
                choice {
                  key
                  type
                  numOfDays
                  price
                }
                options {
                  key
                  type
                  numOfDays
                  price
                }
            }
        }`,
        variables: {},
        token,
    });
    if (e) return e;
    return r.leave_barter_config;
};
